import {Component, OnDestroy} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Attribute, Club} from '~core/models';
import {AttributeService, StorageService} from '~core/services';
import {PriceReductionService} from '~core/services';
import {ButtonsTranslations} from '~shared/components/buttons/buttons-translations.service';
import {SpinnerService} from '~shared/components/buttons/spinner/spinner.service';
import {FormLabelTranslationService} from '~shared/components/form-fields/translations/form-label-translations.service';
import {PriceReduction} from '~core/models/tixx-select/price-reduction';
import {ProcessConfiguration} from '~core/models/tixx-select/process-configuration';
import {ProcessConfigurationService} from '~core/services/tixx-select/process-configuration.service';
import {TixxSelectTranslationsService} from '~shared/translations/alerts/tixx-select-overview-translations.service';
import {EventAdministrationService} from "~features/tixx-select/event-administration.service";

@UntilDestroy()
@Component({
  template: ''
})

export class PriceReductionComponent implements OnDestroy {
  public processConfiguration: ProcessConfiguration;
  public priceReduction: PriceReduction;
  public priceReductionForm: UntypedFormGroup;
  public spinnerName: string;
  public clubAttributes: Array<Attribute>;
  public loading: boolean;
  public multiselectData: Array<any> = [];
  public i18nHeading: string;

  public yesOrNoDropdown: Array<any> = [];

  constructor(
    protected processConfigurationService: ProcessConfigurationService,
    protected attributeService: AttributeService,
    protected storageService: StorageService,
    protected priceReductionService: PriceReductionService,
    public tixxSelectOverviewService: EventAdministrationService,
    public tixxSelectTranslationService: TixxSelectTranslationsService,
    public flTranslations: FormLabelTranslationService,
    public buttonsTranslations: ButtonsTranslations,
    public spinnerService: SpinnerService,
  ) {
    this.processConfigurationService.castCurrentProcessConfiguration.pipe(untilDestroyed(this))
      .subscribe((data: ProcessConfiguration) => this.processConfiguration = data);
    this.priceReductionService.castCurrentPriceReduction.pipe(untilDestroyed(this))
      .subscribe((data: PriceReduction) => this.priceReduction = data);
    this.attributeService.castClubAttributes.pipe(untilDestroyed(this))
      .subscribe((data: Array<Attribute>) => {
        if (data) {
          this.clubAttributes = data;
          this.fillSelectData();
        }
      });
    this.storageService.castSelectedClub.pipe(untilDestroyed(this)).subscribe((data: Club) => {
      if (!this.clubAttributes) {
        this.loading = true;
        this.attributeService.getClubAttribute(data.id).pipe(untilDestroyed(this)).subscribe((res: any) => {
          this.attributeService.announceClubAttributes(res);
          this.loading = false;
        });
      }
    });

    this.yesOrNoDropdown.push(
      {value: true, status: this.flTranslations.i18nYes},
      {value: false, status: this.flTranslations.i18nNo},
    );
  }

  public ngOnDestroy(): void {
    this.tixxSelectOverviewService.toggleEditPriceReductionsModal(false);
    this.tixxSelectOverviewService.toggleCreatePriceReductionsModal(false);
  }

  /**
   * Fill the data for select form field.
   */
  public fillSelectData(): void {
    const data = this.clubAttributes;

    for (const att of data) {
      const obj = {id: att.id, name: att.name};
      this.multiselectData.push(obj);
    }
  }

  /**
   * Updates the club-overview attributes data
   */
  public updateClubAttributesData(attributes: Array<any>): any {
    const attributeNames = attributes.map(o => o.text);
    this.priceReductionForm.get('clubAttributes').setValue(attributeNames);
  }

  public selectChanged(event: any, path: string): void {
    if (event === '0: true') {
      this.priceReductionForm.get(path).patchValue(1);
    } else {
      this.priceReductionForm.get(path).patchValue(null);
    }
  }
}
